import { render, staticRenderFns } from "./Findings.vue?vue&type=template&id=a24a6538&scoped=true&"
import script from "./Findings.vue?vue&type=script&lang=js&"
export * from "./Findings.vue?vue&type=script&lang=js&"
import style0 from "./Findings.vue?vue&type=style&index=0&id=a24a6538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24a6538",
  null
  
)

export default component.exports